import { Box } from "@mui/material";
import ScopeDetail from "../_components/ScopeDetail";

interface Props {
  preview?: boolean;
}

const ScopeOne = ({ preview }: Props) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
      <ScopeDetail scopeId="Scope-1" preview={preview} />
    </Box>
  );
};

export default ScopeOne;
